import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IScopeCount, IUser, IUserCreate, IUserUpdate } from "./users.types";

const API = `${API_URL}/users`;

export const createUser = async (user: IUserCreate) => {
    const result = await axios.post<IUser>(API, user);
    return result.data;
};

export const readUsers = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null,
    organizationId?: number | null,
    isAdmin?: boolean | null,
    invitationAccepted?: boolean | null
) => {
    const url = buildUrl(API, {
        page,
        size,
        ...filter,
        search,
        organization_id: organizationId,
        is_admin: isAdmin,
        invitation_accepted: invitationAccepted,
    });
    const result = await axios.get<Page<IUser>>(url);
    return result.data;
};

export const updateUser = async (id: number, userUpdate: IUserUpdate) => {
    const result = await axios.put<IUser>(`${API}/${id}`, userUpdate);
    return result.data;
};

export const deleteUser = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

export const readUserById = async (id: number) => {
    const result = await axios.get<IUser>(`${API}/${id}`);
    return result.data;
};

export const readUserScopeCount = async (id: number) => {
    const result = await axios.get<IScopeCount>(`${API}/${id}/scopes`);
    return result.data;
};
